import React from 'react';
import {
  CorporateGroupIdentityLoginMethod,
  LoginMethodType,
} from '../../../CorporateGroupIdentityConfigProvider/CorporateGroupIdentityConfigProvider';
import { SocialImage } from '../../SocialImage/SocialImage';

interface Props {
  loginMethod: CorporateGroupIdentityLoginMethod;
}

export const LoginMethodIcon = ({ loginMethod }: Props) => {
  switch (loginMethod.type) {
    case LoginMethodType.APPLE:
      return <SocialImage src="public/images/apple-logo_20200730085920.png" />;
    case LoginMethodType.GOOGLE:
      return <SocialImage src="public/images/google-icon_20200730084705.png" />;
    case LoginMethodType.MICROSOFT:
      return <SocialImage src="public/images/microsoft-icon_20210618025914.png" />;
    case LoginMethodType.MYTWC:
      return <SocialImage src={loginMethod.iconPath ?? ''} />;
    default:
      return null;
  }
};
